<!--
 * @Author: liushengjiang 1947448287@qq.com
 * @Date: 2021-12-28 15:26:11
 * @LastEditors: liushengjiang 1947448287@qq.com
 * @LastEditTime: 2023-07-05 17:01:49
 * @FilePath: \petro-web-chemicals-buyerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\components\SearchBar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="price-search">
    <van-search v-model="value" placeholder="请输入关键词搜索" @search="onSearch(value)" :clearable="false">
      <template #left-icon>
        <img src="@/assets/imgs/搜索1.png" alt="" style="display: none;">
      </template>
      <template #right-icon>
        <img src="@/assets/imgs/搜索1.png" alt="" @click="onSearch(value)">
      </template>
    </van-search>
  </div>
</template>

<script>
import fliter from "assets/imgs/product_filter.png";
export default {
  name: "PriceSearch",
  components: {
  },
  props: {
    filterIconFlag: {
      type: Boolean,
      default: () => {
        return true;
      },
    }
  },
  data() {
    return {
      value: '',
      fliterImg: fliter
    };
  },
  methods: {
    onSearch(value) {
      console.log(value);
      this.$router.push({
        path: '/planSale',
        query: { val: value }
      });
      this.$emit("onSearch", value);
    },
    onFliter() {
      this.$emit("onFliter");
    }
  }
};
</script>

<style lang="stylus" scoped>
.price-search {
  padding: 0 32px;
  margin: 30px 0 10px 0;

  >>> .van-search {
    width: 100%;
    height: 72px;
    background: #FFFFFF;
    border-radius: 36px 36px 36px 36px;
  }

  >>> .van-search__content {
    border-radius: 36px 36px 36px 36px;
  }

  >>> .van-field__control {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #999999;
  }

  >>> .van-field__right-icon {
    img {
      width: 32px;
      height: 32px;
    }
  }
}
</style>
